import {
	forwardRef,
	HTMLAttributes,
	useEffect,
	useImperativeHandle,
	useRef
} from 'react'
import { attachFadingScrollbar } from './fading-scrollbar'

/**
 * A scroll box whose bar fades in while it moves and out when it settles;
 * `useFadingScrollbar` is for the boxes we do not render ourselves.
 *
 * It does NOT set its own overflow — the callers need different layout boxes, so
 * this only says how the bar behaves.
 */
export const FadingScrollArea = forwardRef<
	HTMLDivElement,
	HTMLAttributes<HTMLDivElement>
>(({ children, ...rest }, ref) => {
	const box = useRef<HTMLDivElement>(null)
	useImperativeHandle(ref, () => box.current as HTMLDivElement)

	useEffect(() => {
		if (!box.current) return
		return attachFadingScrollbar(box.current)
	}, [])

	return (
		<div ref={box} {...rest}>
			{children}
		</div>
	)
})
